import React from "react"

import { PageLayout } from "../PageLayout"

export function MDXPageLayout({ children }) {
  return <PageLayout>{children}</PageLayout>
}

export default MDXPageLayout
